<template>
    <div class="container-fluid">
        <div class="page-header">
            <div>
                <h1><span>Сравнение товаров</span></h1>
                <q-btn v-if="products.length" flat class="icon-wrapper"
                       @click.prevent="clearAllProducts()"
                       label="Очистить всё">
                    <span class="icon remove"></span>
                </q-btn>
            </div>
            <ul v-if="products.length" class="nav">
                <li v-if="categoryProducts(category.id).length"
                    v-for="category in categories"
                    :key="`category-${category.id}`"
                    class="nav-item"
                    @click="selectCategory(category.id)">
                    <span class="nav-link" :class="{'active' : selectedCategoryId === category.id}">
                        {{ category.name }} <span>({{ categoryProducts(category.id).length }})</span>
                    </span>
                </li>
            </ul>
        </div>
        <div class="comparison-products" v-if="products.length">
            <div ref="carousel">
                <div class="carousel product-carousel">
                    <carousel ref="product-main-carousel"
                              :items="products"
                              :show-pagination="false"
                              :show-navigation="false"
                              :options="carouselOptions"
                              @slideChange="slideChange">
                        <template #slide="{ item }">
                            <comparison-card :product="item"></comparison-card>
                        </template>
                    </carousel>
                    <navigation v-if="showNavigation" @slide-prev="slidePrev" @slide-next="slideNext"></navigation>
                </div>
            </div>
            <div v-show="hasStickyHeader" ref="header">
                <div :class="{'container-fluid': hasStickyHeader}">
                    <div class="carousel product-carousel">
                        <carousel ref="product-carousel"
                                  :items="products"
                                  :show-pagination="false"
                                  :show-navigation="false"
                                  :options="carouselOptions"
                                  @slideChange="slideChange">
                            <template #slide="{ item }">
                                <comparison-card :product="item"
                                                 :hasStickyHeader="hasStickyHeader"></comparison-card>
                            </template>
                        </carousel>
                        <navigation v-if="showNavigation" @slide-prev="slidePrev" @slide-next="slideNext"></navigation>
                    </div>
                </div>
            </div>
            <div>
                <div class="checkbox">
                    <input id="show-only-diff" type="checkbox" v-model="showOnlyDifferences">
                    <label for="show-only-diff">Показывать только различия</label>
                </div>
                <q-btn flat class="icon-wrapper" @click.prevent="clearCategoryProducts()" label="Очистить категорию">
                    <span class="icon remove"></span>
                </q-btn>
            </div>
            <template v-if="option.show" v-for="option in productOptions">
                <div class="option-toggle" @click="switchOptionVisibility(option.slug)">
                    <span class="option-name">{{ option.name }}</span>
                    <span class="option-arrow"></span>
                </div>
                <hr>
                <div v-if="option.open">
                    <carousel :ref="`${option.slug}-carousel`"
                              :class="`${option.slug}-carousel`"
                              :items="products"
                              :options="carouselOptions"
                              :show-pagination="false"
                              :show-navigation="false">
                        <template #slide="{ item }">
                            <div :class="`product-slug-${option.slug}`">
                                <template v-if="option.slug === 'rating'">
                                    <div class="product-rating-stars">
                                        <span v-for="i in 5" :key="`rating-${i}`" class="star icon"
                                              :class="{
                                                'fill': i <= Math.round(item.reviews.rating)
                                              }"></span>&nbsp;({{ item.reviews ? item.reviews.count : 0 }})
                                    </div>
                                </template>
                                <template v-else-if="option.slug === 'special_offer'">
                                    <div class="product-card-badge"
                                         :class="{
                                            'product-card-badge--new': item.new,
                                            'product-card-badge--sale': item.discount,
                                        }">
                                        <span>{{
                                                item.options[option.slug] ? item.options[option.slug] : '-'
                                            }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ item.options[option.slug] ? item.options[option.slug] : '-' }}</div>
                                </template>
                            </div>
                        </template>
                    </carousel>
                </div>
            </template>
        </div>
        <div v-else>
            <div class="empty-catalog">
                <div class="empty-catalog-header">
                    <h2>В сравнении пока ничего нет</h2>
                    <p><a href="/catalog/">Перейдите к каталогу товаров</a> и добавьте интересующие вас товары</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Carousel from "../Carousel/Carousel.vue";
import Navigation from "../Carousel/Navigation.vue";
import {mapActions, mapState} from "vuex";

export default {
    components: {Navigation, Carousel},
    props: {
        categories: {
            type: Array,
        },
        options: {
            type: Array,
        },
        items: {
            type:[Array,Object],
        },
    },
    data() {
        return {
            selectedCategoryId: null,
            productOptions: [],
            hasStickyHeader: false,
            index: 0,
            carouselOptions: {
                spaceBetween: 5,
                breakpoints: {
                    1200: {
                        slidesPerView: 5,
                    },
                    1024: {
                        slidesPerView: 4,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 2,
                    }
                },
            },
            showOnlyDifferences: false,
            stickyHeaderClass: "is-sticky"
        }
    },
    mounted() {
        this.selectedCategoryId = this.categories.length ? this.categories[0].id : null;
        this.productOptions = this.options.map(item => ({...item, ...{open: true, show: true}}));

        window.addEventListener("scroll", () => {
            if (window.pageYOffset > this.$refs.carousel.offsetTop) {
                this.$refs.header.classList.add(this.stickyHeaderClass);
                this.hasStickyHeader = true;
            } else {
                this.$refs.header.classList.remove(this.stickyHeaderClass);
                this.hasStickyHeader = false;
            }
        });
    },
    methods: {
        ...mapActions('product', ['deleteComparisonProducts']),
        slideChange(index) {
            if (this.index === index) {
                return true;
            }

            if (this.index < index) {
                for (let i in this.productOptions) {
                    if (this.productOptions[i].show) {
                        let ref = this.productOptions[i]['slug'] + '-carousel';
                        this.$refs[ref][0].slideNext();
                    }
                }
            } else {
                for (let i in this.options) {
                    if (this.productOptions[i].show) {
                        let ref = this.productOptions[i]['slug'] + '-carousel';
                        this.$refs[ref][0].slidePrev();
                    }
                }
            }
            this.index = index;
        },
        slidePrev() {
            this.$refs['product-carousel'].slidePrev();
            this.$refs['product-main-carousel'].slidePrev();
        },
        slideNext() {
            this.$refs['product-carousel'].slideNext();
            this.$refs['product-main-carousel'].slideNext();
        },
        switchOptionVisibility(slug) {
            const index = this.productOptions.findIndex(p => p.slug === slug);

            if (index !== -1) {
                this.productOptions[index].open = !this.productOptions[index].open;
            }
        },
        clearAllProducts() {
            this.deleteComparisonProducts({ids: []});
        },
        clearCategoryProducts() {
            this.deleteComparisonProducts({
                ids: this.products.filter(p => p.category_id === this.selectedCategoryId).map(p => p.id)
            });
            this.selectedCategoryId = this.categories[0].id;
        },
        selectCategory(id) {
            this.selectedCategoryId = id;
        },
        categoryProducts(categoryId) {
            let products = this.items[categoryId] ?? [];

            return products.filter(p => this.comparisonProducts.includes(parseInt(p.id)));
        },
        hideEqualOptions()  {
            for (const index in this.productOptions) {
                let equal = true;
                let optionValue = false;
                for (const i in this.products) {
                    for (const optionSlug in this.products[i].options) {
                        if (optionSlug === this.productOptions[index].slug) {
                            if (optionValue !== false) {
                                if (optionValue !== this.products[i].options[optionSlug]) {
                                    equal = false;
                                }
                            }
                            optionValue = this.products[i].options[optionSlug];
                        }
                    }
                }
                this.productOptions[index].show = !equal;
            }
        },
        showAllOptions() {
            for (const index in this.productOptions) {
                this.productOptions[index].show = true;
            }
        }
    },
    watch: {
        showOnlyDifferences(val) {
            if (val) {
                this.hideEqualOptions();
            } else {
                this.showAllOptions();
            }
        },
        selectedCategory() {
            if (this.showOnlyDifferences) {
                this.hideEqualOptions();
            } else {
                this.showAllOptions();
            }
        },
        products(val) {
            if (!val.length && this.comparisonProducts.length) {
                const items = Object.values(this.items).flat();
                const item = items.find(i => i.id === this.comparisonProducts[0]);

                this.selectCategory(item.category_id);
            }
        }
    },
    computed: {
        ...mapState('product', ['comparisonProducts']),

        products () {
            const categoryId = this.selectedCategoryId ? this.selectedCategoryId : (this.categories[0] ?? false);

            if (!categoryId) {
                return [];
            }

            return this.categoryProducts(categoryId);
        },
        showNavigation () {
            let countPerPage = 0;
            for (const resolution in this.carouselOptions.breakpoints) {
                if (window.innerWidth >= resolution) {
                    countPerPage = this.carouselOptions.breakpoints[resolution].slidesPerView;
                }
            }

            return this.products.length > countPerPage;
        }
    }
}
</script>
